var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-view',{attrs:{"title":"Dirección de Planeación - Reporte de Saldos por Partida"}},[_c('div',{staticClass:"container-fluid mt-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('reporte-planeacion-saldos-partidas')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }